import axios from 'axios';

export const state = {
    all: [],
    allType: [],
    all_vp: [],
    all_shop: [],
    all_stock: [],
    all_marketplace: [],
    manufacturers: [],
   
}

export const getters = {
    getAll: (state) => state.all,
    getAllType: (state) => state.allType,
    getAllVP: (state) => state.all_vp,
    getAllShop: (state) => state.all_shop,
    getAllStock: (state) => state.all_stock,
    getAllMarketplace: (state) => state.all_marketplace,
}

export const actions = {
    async fetchAll({ commit }) {
        const response = await axios.get(`/manufacturers/all`);
        commit('SET_ALL', response.data);
    },
    async fetchAllType({ commit }, data) {
        data.supplierValidation = true
        const response = await axios.post(`/manufacturers/all/type`, data );
        commit('SET_ALL_TYPE', response.data);
        // commit('SET_ALL_TYPE', {result: response.data, type: data.type});
    },
    async fetchAllTypeSpecific({ commit }, data) {
        data.supplierValidation = true
        const response = await axios.post(`/manufacturers/all/type`, data );
        commit('SET_ALL_TYPE_SPECIFIC', {result: response.data, vuexType: data.vuexType});
    },
    async fetchManufacturers({ commit }, params) {
        const { data } = await axios.post(`/commercialv2/manufacturers/list`, params);
        commit('SET_MANUFACTURERS', data.data);
    },
}


export const mutations = {
    SET_ALL: (state, result) => state.all = result,
    SET_ALL_TYPE: (state, result) => state.allType = result,
    SET_ALL_TYPE_SPECIFIC: (state, {result, vuexType}) => state[`all_${vuexType}`] = result,
    // SET_ALL_TYPE: (state, {result, type}) => type == 'shop' ? state.allType = result : (type == 'vp' ? state.allVP = result : false),

    SET_MANUFACTURERS: (state, manufacturers) => {
        state.manufacturers = manufacturers;
    },
}
